import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export interface DesignProjectDialogData {
  /** Names already taken, compared case-insensitively. */
  existingNames: string[];
}

@Component({
  selector: 'app-design-project-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './design-project-dialog.component.html',
  styleUrl: './design-save-as-dialog.component.scss',
})
export class DesignProjectDialogComponent {
  name = '';
  error = '';

  constructor(
    private readonly dialogRef: MatDialogRef<DesignProjectDialogComponent, string | null>,
    @Inject(MAT_DIALOG_DATA) readonly data: DesignProjectDialogData,
  ) {}

  create(): void {
    const name = this.name.trim();
    if (!name) {
      this.error = 'Give your project a name.';
      return;
    }
    if (this.data.existingNames.some((existing) => existing.trim().toLowerCase() === name.toLowerCase())) {
      this.error = `A project called "${name}" already exists.`;
      return;
    }
    this.dialogRef.close(name);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
